// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#message-sent-notification{padding-bottom:20px}#message-sent-notification .Animation{pointer-events:none}#message-sent-notification .sent-notification-body{margin-bottom:20px;text-align:center;font-family:\"GothamSSm-Book\",Arial,sans-serif;color:#a9a9a9}#message-sent-notification button{display:block;margin:0 auto}\n", ""]);
// Exports
module.exports = exports;
